import store from '@/store';

const userRedirects = {
  'dispenser_admin': 'dispensers',
  'admin': 'dispensers-admin'
};

export default (userType) => {
  return (from, to, next) => {
    
    let org = from.params.organization_uuid;

    if (!store.getters.hasRole(userType, org)) {
      return next(userRedirects[store.getters.user.type]);
    }
    return next();
  };
};
